import React, { createRef, useEffect, useRef, useState } from "react";
import "../../css/Dashboard.scss";
import "../../css/Common.scss";
import { Button, ToolbarItem } from "@progress/kendo-react-buttons";
import { useLocation, useNavigate } from "react-router-dom";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import Breadcrumbs from "../../components/Breadcrumbs";
import { formatDateDMY } from "../../components/commoncomponents";
import { MyDatePicker } from "../MyDatePicker";
import { ExternalDropZone, UploadFileInfo } from "@progress/kendo-react-upload";
import { Input, RadioButton } from "@progress/kendo-react-inputs";
import { Signature } from "@progress/kendo-react-inputs";
import { Upload } from "@progress/kendo-react-upload";
import axios from "axios";
import { commonBaseUrl, commonImageUrl } from "../../../services/CommonUtil";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog } from "@progress/kendo-react-dialogs";

interface BookingDetail {
  SpaceBooked: string;
  BookingDate: string;
  BookingFrom: Date;
  BookingTo: Date;
  Duration: string;
  Deposit: string;
  TotalCost: string;
}

interface CustomerDetails {
  Name: string;
  Mobile: string;
  Email: string;
  Address: string;
  Notes: string;
}

interface Row {
  type: string;
  description: string;
  rent: number;
  discount: number;
  subTotal: number;
}

export const EditContractMasterList = () => {
  const baseUrl = commonBaseUrl();
  const imageUrl = commonImageUrl();
  const Location = useLocation();
  const navigate = useNavigate();
  const hasFetched = useRef(false);
  const [view, setView] = useState(false);
  const [BookingDetails, setBookingCustomerDetails] = useState<BookingDetail>();
  const [customerDetails, setCustomerDetails] = useState<CustomerDetails>();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [errorstartDate, setErrorstartDate] = useState<string | null>(null);
  const [errorDate, setErrorDate] = useState<string | null>(null);
  const [editorContent, setEditorContent] = useState("");
  const handleEditorChange = (event: any) => {
    setEditorContent(event.html);
    console.log(event.html, "<<");
  };

  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [staffName, setStaffName] = useState("");
  const [staffDes, setStaffDes] = useState("");
  const [staffNameId, setStaffNameId] = useState();

  const [imageDatastaff, setImageDatastaff] = useState("");
  const [imageDatacustomer, setImageDatacustomer] = useState("");
  const [imageDatav1, setImageDatav1] = useState("");
  const [imageDatav2, setImageDatav2] = useState("");

  const [selectedValuestaff, selectedValuestaffSet] = useState("");
  const [selectedValuecustomer, selectedValuecustomerSet] = useState("");
  const [selectedValuev1, setSelectedValuev1] = useState("");
  const [selectedValuev2, selectedValuev2Set] = useState("");

  const [currentFilestaff, setCurrentFilestaff] = useState<UploadFileInfo>();
  const [currentFilecustomer, setCurrentFilecustomer] =
    useState<UploadFileInfo>();
  const [currentFilev1, setCurrentFilev1] = useState<UploadFileInfo>();
  const [currentFilev2, setCurrentFilev2] = useState<UploadFileInfo>();

  const [staffNameError, setStaffNameError] = useState("");
  const [staffDesError, setStaffError] = useState("");
  const [staffImageError, setStaffImageError] = useState("");
  const [customerImageError, serCustomerImageError] = useState("");
  const [witness1Error, setWitness1Error] = useState("");
  const [witness2Error, setWitness2Error] = useState("");

  const [statusDialog, statusDialogSet] = useState(false);
  const [alertState, alertStateSet] = useState(false);
  const [alert, alertSet] = useState("");
  const [loading, setLoading] = useState(false); // State for loading

  const base64FileContent =
    "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";

  const validate = () => {
    // Returns true if no errors
  };
  const handleSubmit = () => {
    let validate = true;

    if (!staffName.trim()) {
      setStaffNameError("Staff Name is required.");
      validate = false;
    } else {
      setStaffNameError("");
    }

    if (!staffDes.trim()) {
      setStaffError("Staff Designation is required.");
      validate = false;
    } else {
      setStaffError("");
    }

    // Sign flow
    // if (imageDatastaff === "") {
    //   setStaffImageError("Staff Signature is required");
    //   validate = false;
    // } else {
    //   setStaffImageError("");
    // }

    // if (imageDatacustomer === "") {
    //   serCustomerImageError(" Customer Signature is required");
    //   validate = false;
    // } else {
    //   serCustomerImageError("");
    // }

    // if (imageDatav1 === "") {
    //   setWitness1Error("Witness sign 1 is required");
    //   validate = false;
    // } else {
    //   setWitness1Error("");
    // }

    // if (imageDatav2 === "") {
    //   setWitness2Error("Witness sign 2 is required");
    //   validate = false;
    // } else {
    //   setWitness2Error("");
    // }

    // console.log("sign", imageDatastaff);
    if (validate == true) {
      addDetailInvoice();
      // console.log("Form submitted successfully!");
    } else {
      console.log("Validation errors:");
    }
  };

  // Function to convert Base64 to Blob
  const base64ToBlob = (base64: any, contentType = "application/pdf") => {
    const byteCharacters = atob(base64);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0)
    );
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  };

  //styles
  const customStyles = `
.no-wheel input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* Hide spinner controls */
  pointer-events: none;
  user-select: none;
}

.no-wheel input::-webkit-inner-spin-button,
.no-wheel input::-webkit-calendar-picker-indicator {
  display: none;
}

.no-wheel input::-moz-inner-spin-button {
  display: none;
}
`;

  // Breadcrums
  const breadCrumbsData = [
    {
      id: "1",
      text: "Masters",
      route: "",
    },
    {
      id: "2",
      text: "Contract master",
      route: "/masters/contractmaster",
    },
    {
      id: "3",
      text: "Add Contract",
      route: "",
    },
  ];

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
    validateDates(date, endDate); // Validate when start date is changed
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
    validateDates(startDate, date); // Validate when end date is changed
  };

  const validateDates = (start: Date | null, end: Date | null) => {
    if (start && end && end < start) {
      setErrorDate("End date cannot be before start date.");
      return false;
    }
    setErrorDate(null); // Clear error if dates are valid
    return true;
  };

  ////////////////////////////////////////////////////////////////////////////////////
  const [selectedOption, setSelectedOption] = useState("Terms & Conditions");
  const [signatureMethod, setSignatureMethod] = useState("Upload File");
  const [uploadedFile, setUploadedFile] = useState(null);

  const termsOptions = [
    "Terms & Conditions",
    "Privacy Policy",
    "License Agreement",
  ];

  const signatureOptions = ["Saved Signs", "Upload File", "Draw Signature"];

  const handleUpload = (event: any) => {
    setUploadedFile(event.newState[0].name); // Capture uploaded file
  };

  const [newVarientError, newVarientErrorSet] = useState("");
  const uploadRefs = createRef<Upload>();
  const hint = (
    <span>Click to select files or Drag and drop files here to upload.</span>
  );

  const note = (
    <span>
      Only JPEG, JPG, PNG and PDF files are allowed. The maximum upload size is
      2 MB
    </span>
  );
  const [errorimageMessage, setErrorimegeMessage] = useState<string>("");

  function onSaveRequeststaff(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any },
    onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    setCurrentFilestaff(currentFile);
    const uid = currentFile.uid;
    console.log(currentFile, "121");

    return new Promise<{ uid: string }>((resolve, reject) => {
      if (
        currentFile.validationErrors &&
        currentFile.validationErrors.length > 0
      ) {
        reject({ uid: uid });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result && typeof reader.result === "string") {
            const base64Result = reader.result.split(",")[1];
            console.log(base64Result, "this< base64");
            setImageDatastaff(base64Result);
            resolve({ uid: uid });
          } else {
            reject({ uid: uid });
          }
        };
        reader.onprogress = (data) => {
          onProgress(uid, data);
        };
        reader.onabort = () => {
          reject({ uid: uid });
        };
        reader.onerror = () => {
          reject({ uid: uid });
        };

        reader.readAsDataURL(currentFile.getRawFile!());
      }
    });
  }

  function onSaveRequestCustomer(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any },
    onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    setCurrentFilecustomer(currentFile);
    const uid = currentFile.uid;
    console.log(currentFile, "121");

    return new Promise<{ uid: string }>((resolve, reject) => {
      if (
        currentFile.validationErrors &&
        currentFile.validationErrors.length > 0
      ) {
        reject({ uid: uid });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result && typeof reader.result === "string") {
            const base64Result = reader.result.split(",")[1];
            console.log(base64Result, "this< base64");
            setImageDatacustomer(base64Result);
            resolve({ uid: uid });
          } else {
            reject({ uid: uid });
          }
        };
        reader.onprogress = (data) => {
          onProgress(uid, data);
        };
        reader.onabort = () => {
          reject({ uid: uid });
        };
        reader.onerror = () => {
          reject({ uid: uid });
        };

        reader.readAsDataURL(currentFile.getRawFile!());
      }
    });
  }

  function onSaveRequestv1(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any },
    onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    setCurrentFilev1(currentFile);
    const uid = currentFile.uid;
    console.log(currentFile, "121");

    return new Promise<{ uid: string }>((resolve, reject) => {
      if (
        currentFile.validationErrors &&
        currentFile.validationErrors.length > 0
      ) {
        reject({ uid: uid });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result && typeof reader.result === "string") {
            const base64Result = reader.result.split(",")[1];
            console.log(base64Result, "this< base64");
            setImageDatav1(base64Result);
            resolve({ uid: uid });
          } else {
            reject({ uid: uid });
          }
        };
        reader.onprogress = (data) => {
          onProgress(uid, data);
        };
        reader.onabort = () => {
          reject({ uid: uid });
        };
        reader.onerror = () => {
          reject({ uid: uid });
        };

        reader.readAsDataURL(currentFile.getRawFile!());
      }
    });
  }

  function onSaveRequestv2(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any },
    onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    setCurrentFilev2(currentFile);
    const uid = currentFile.uid;
    console.log(currentFile, "121");

    return new Promise<{ uid: string }>((resolve, reject) => {
      if (
        currentFile.validationErrors &&
        currentFile.validationErrors.length > 0
      ) {
        reject({ uid: uid });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result && typeof reader.result === "string") {
            const base64Result = reader.result.split(",")[1];
            console.log(base64Result, "this< base64");
            setImageDatav2(base64Result);
            resolve({ uid: uid });
          } else {
            reject({ uid: uid });
          }
        };
        reader.onprogress = (data) => {
          onProgress(uid, data);
        };
        reader.onabort = () => {
          reject({ uid: uid });
        };
        reader.onerror = () => {
          reject({ uid: uid });
        };

        reader.readAsDataURL(currentFile.getRawFile!());
      }
    });
  }

  function onRemoveRequeststaff(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any }
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    const uid = currentFile.uid;
    setImageDatastaff("");
    return new Promise<{ uid: string }>((resolve) => {
      resolve({ uid: uid });
    });
  }

  function onRemoveRequestcustomer(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any }
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    const uid = currentFile.uid;
    setImageDatacustomer("");
    return new Promise<{ uid: string }>((resolve) => {
      resolve({ uid: uid });
    });
  }

  function onRemoveRequestv1(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any }
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    const uid = currentFile.uid;
    setImageDatav1("");
    return new Promise<{ uid: string }>((resolve) => {
      resolve({ uid: uid });
    });
  }

  function onRemoveRequestv2(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any }
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    const uid = currentFile.uid;
    setImageDatav2("");
    return new Promise<{ uid: string }>((resolve) => {
      resolve({ uid: uid });
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////

  const [value, setValue] = React.useState<string>();
  const [imageURL, setImageURL] = React.useState<string>();

  const handleChangestaff = async (event: any) => {
    const signatureDataURL = event;
    if (event.value !== undefined) {
      const [metadata, base64Data] = event.value.split(",");
      console.log(base64Data, "dfghjkjhgfdsfghj");
      setImageDatastaff(base64Data);

      const file = new File([base64Data], "signature.png", {
        type: "image/png",
      });
      const mockFile: UploadFileInfo = {
        uid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: file.name,
        size: file.size,
        extension: ".png",
        status: 0,
        progress: 0,
        validationErrors: [],
        getRawFile: () => file,
      };

      setCurrentFilestaff(mockFile);
    } else {
      setImageDatastaff("");
    }
  };

  const handleChangecustomer = async (event: any) => {
    const signatureDataURL = event;
    if (event.value !== undefined) {
      const [metadata, base64Data] = event.value.split(",");
      console.log(base64Data, "dfghjkjhgfdsfghj");
      setImageDatacustomer(base64Data);

      const file = new File([base64Data], "signature.png", {
        type: "image/png",
      });
      const mockFile: UploadFileInfo = {
        uid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: file.name,
        size: file.size,
        extension: ".png",
        status: 0,
        progress: 0,
        validationErrors: [],
        getRawFile: () => file,
      };

      setCurrentFilecustomer(mockFile);
    } else {
      setImageDatacustomer("");
    }
  };

  const handleChangev1 = async (event: any) => {
    const signatureDataURL = event;
    if (event.value !== undefined) {
      const [metadata, base64Data] = event.value.split(",");
      console.log(base64Data, "dfghjkjhgfdsfghj");
      setImageDatav1(base64Data);

      const file = new File([base64Data], "signature.png", {
        type: "image/png",
      });
      const mockFile: UploadFileInfo = {
        uid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: file.name,
        size: file.size,
        extension: ".png",
        status: 0,
        progress: 0,
        validationErrors: [],
        getRawFile: () => file,
      };

      setCurrentFilev1(mockFile);
    } else {
      setImageDatav1("");
    }
  };

  const handleChangev2 = async (event: any) => {
    const signatureDataURL = event;
    if (event.value !== undefined) {
      const [metadata, base64Data] = event.value.split(",");
      console.log(base64Data, "draw image");
      setImageDatav2(base64Data);

      const file = new File([base64Data], "signature.png", {
        type: "image/png",
      });
      const mockFile: UploadFileInfo = {
        uid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        name: file.name,
        size: file.size,
        extension: ".png",
        status: 0,
        progress: 0,
        validationErrors: [],
        getRawFile: () => file,
      };

      setCurrentFilev2(mockFile);
    } else {
      setImageDatav2("");
    }
  };

  const revokeImageURL = () => {
    if (imageURL) {
      console.log("cleanup");
      URL.revokeObjectURL(imageURL);
      setImageURL(undefined);
    }
  };

  const onSave = () => {
    if (value) {
      console.log(value, "sign");
      // saveAs(value, "signature.png");
    }
  };

  const onClear = () => {
    setValue(undefined);
    revokeImageURL();
  };

  // Dropdown flow
  const [users, setUsers] = useState([]);
  const [selectUser, setSelectUser] = useState({ Id: 0, Name: "Select User" });
  const [bookingId, bookingIdSet] = useState();
  const [staffData, setStaffData] = useState([]);
  const [selectStaffName, setSelectStaffName] = useState({
    id: 0,
    name: "Select Staff Name",
    roleId: 0,
  });
  const [selectBookingId, setSelectBookingId] = useState({
    Id: 0,
    bookingId: "Select Booking Id",
  });
  const [selectBookingIds, setSelectBookingIds] = useState({
    id: 0,
    bookingId: "Select Booking Id",
  });
  const [durationtype, setDurationType] = useState("");
  const [selectedTax, setSelectedTax] = useState();
  const [invoiceidEnabler, setInvoiceEnabler] = useState(false);
  const [bookingIdEnabler, setBookingIdEnabler] = useState(false);

  const [detailsEnabler, setDetailsEnabler] = useState(false);
  const [loader, setLoader] = useState(false);
  const [alertdilog, alertdilogSet] = useState("");
  const [deposit, setdeposit] = useState(0);
  const [taxRate, setTaxRate] = useState<number>(0);
  const [rentAmount, setRentAmount] = useState(0);
  const [rows, setRows] = useState<Row[]>([]);
  const [spaceId, getSpaceId] = useState();
  const locations = useLocation();

  useEffect(() => {
    // Prevent second call
    if (locations.state !== null) {
      console.log(locations.state, "kasytfdkhgsvdhkfkysdf");
      setDetailsEnabler(true);
      setInvoiceEnabler(true);
      setBookingIdEnabler(true);
      setView(locations.state.view);
      getContractMaster(locations.state.contractId);
    } else {
      if (hasFetched.current) return;
      hasFetched.current = true;
      fetchUsers();
      fetchStaffData();
      // downloadFile();
    }
  }, []);

  const downloadFile = () => {
    const blob = base64ToBlob(base64FileContent);

    const url = window.URL.createObjectURL(blob);
    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = "Contract.pdf"; // Default name for the downloaded file
    document.body.appendChild(link);
    link.click();
    // Clean up the URL object
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const imageBaseUrl = commonImageUrl();
  const [ImagelistDetails, setImageListDetails] = useState([]);
  const getContractMaster = async (Id: any) => {
    try {
      //contractMasterget
      const responseDetails = await axios.get(
        `${baseUrl}odata/Contracts(${Id})`
      );

      setStaffName(responseDetails.data.value.StaffName);
      setStaffNameId(responseDetails.data.value.StaffDesignationId);
      setStaffDes(responseDetails.data.value.StaffDesignation);

      console.log(responseDetails, "shugfusvludfvusydfuysdvugsv");

      //booking
      const responseBooking = await axios.get(
        `${baseUrl}odata/Bookings(${responseDetails.data.value[0].BookingId})`
      );
      // const responseDesignation = await axios.get(
      //   `${baseUrl}MasterData/GetAllDesignations(${Id})`
      // );
      const userId = responseBooking.data.UserId;

      const responceUser = await axios.get(`${baseUrl}odata/Users(${userId})`);
      const contractDetails = responseDetails.data.value[0];
      const bookingDetails = responseBooking.data;
      const userDetails = responceUser.data.value[0];
      // const designationDetail = responseDesignation.data.value[0];

      console.log(
        contractDetails,
        "wedrtghyujioiuhygtfredswedfrgthyjukijuhygtfrde"
      );
      console.log(
        bookingDetails,
        "wedrtghyujioiuhygtfredswedfrgthyjukijuhygtfrdesss"
      );
      console.log(
        userDetails,
        "wedrtghyujioiuhygtfredswedfrgthyjukijuhygtfrde"
      );
      ///////
      const spaceIdContract = bookingDetails.SpaceId;
      const contractDurationId = bookingDetails.DurationId;
      const responseSpace = await axios.get(
        `${baseUrl}odata/SpaceHeaders(${spaceIdContract})`
      );

      const responseDuration = await axios.get(
        `${baseUrl}odata/Durations/${contractDurationId}`
      );

      const contractSpaceDetails = responseSpace.data;
      const contractDurationDetails = responseDuration.data.value[0];

      console.log(
        responseSpace.data,
        "wedrtghyujioiuhygtfredswedfrgthyjukijuhygtfrdes"
      );
      console.log(
        responseDuration.data.value,
        "wedrtghyujioiuhygtfredswedfrgthyjukijuhygtfrde"
      );
      ////////

      setSelectUser(userDetails);
      // setSelectStaffName(designationDetail);
      setSelectBookingIds(bookingDetails);
      setSelectBookingId(bookingDetails);
      setStaffName(contractDetails.StaffName);
      setStaffDes(contractDetails.StaffDesignation);
      setInvoiceNumber(contractDetails.InvoiceNumber);

      const spaceDetailss = {
        SpaceBooked: contractSpaceDetails.SpaceName,
        BookingDate: contractDetails.BookingDate,
        BookingFrom: contractDetails.PeriodStart,
        BookingTo: contractDetails.PeriodEnd,
        Duration: contractDurationDetails.Description,
        Deposit: `${bookingDetails.Deposit}`,
        TotalCost: bookingDetails.TotalAmount,
      };
      setBookingCustomerDetails(spaceDetailss);

      const userDetailsshow = {
        Name: userDetails.Name,
        Mobile: userDetails.Mobile,
        Email: userDetails.Email,
        Address: contractDetails.Address,
        Notes: "",
      };
      setCustomerDetails(userDetailsshow);

      // https://dev-cw-api.equadriga.in/odata/DocumentUploads?$filter=refno%20eq%2055

      const contractImageLists = await axios.get(
        `${baseUrl}odata/DocumentUploads?$filter=refno eq ${contractDetails.Id} and contains(reftype, 'Sign')`
      );
      console.log(
        contractImageLists.data.value,
        "sdfghjkjhgfdsasdfghjkloikjuhygtfrdewsdfghuji"
      );
      setImageListDetails(contractImageLists.data.value);
      const image11 = contractImageLists.data.value.filter(
        (Data: any) => Data.SubType === "staff"
      );
      setImg1(image11[0].ImagePath);
      const image12 = contractImageLists.data.value.filter(
        (Data: any) => Data.SubType === "customer"
      );
      setImg2(image12[0].ImagePath);
      const image13 = contractImageLists.data.value.filter(
        (Data: any) => Data.SubType === "witness1"
      );
      setImg3(image13[0].ImagePath);
      const image14 = contractImageLists.data.value.filter(
        (Data: any) => Data.SubType === "witness2"
      );
      setImg4(image14[0].ImagePath);

      console.log(image11, "sdfghjukijuhgfdsxdcfghjkl");
    } catch (e) {}
  };

  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");
  const [img3, setImg3] = useState("");
  const [img4, setImg4] = useState("");

  const fetchUsers = async (userId?: any) => {
    try {
      const response = await axios.get(
        `${baseUrl}odata/Users?$filter=(IsActive eq true)and(RoleId eq 2)`
      );

      const usersData = response.data.value || [];
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchStaffData = async () => {
    try {
      const response = await axios.get(`${baseUrl}odata/GetAllManagers`);

      const designationData = response.data.content;
      setStaffData(designationData);
    } catch (error) {
      console.error("Error fetching Designation Data:", error);
    }
  };

  //While select the user id
  const getinvoiceData = async (userData: any) => {
    console.log(userData, "sdfghjklkjhgbvfcdsxdfghjkjhgfdfghj");
    // const responceInvoiceData = await axios.get(`${baseUrl}odata/GetAllInvoiceByBookingId?bookingId=${}`)

    const details = {
      Name: userData.Name === null ? "" : userData.Name,
      Mobile: userData.Mobile === null ? "" : userData.Mobile,
      Email: userData.Email === null ? "" : userData.Email,
      Address: `${
        userData.Address !== null && userData.Address !== ""
          ? userData.Address + ","
          : ""
      } ${
        userData.Address2 !== null && userData.Address2.trim() !== ""
          ? userData.Address2 + ","
          : ""
      } ${
        userData.City !== null && userData.City !== ""
          ? userData.City + ","
          : ""
      } ${
        userData.Country !== null && userData.Country !== ""
          ? userData.Country + ","
          : ""
      }`,
      Notes: "",
    };
    setLoader(false);
    setCustomerDetails(details);
  };
  const [spaceIdValue, setSpaceIdValue] = useState(0);
  const fetchUserBooking = async (Id: any) => {
    console.log("Id from user -->", Id);
    try {
      const response = await axios.get(
        `${baseUrl}odata/GetAllInvoiceByUserId?userId=${Id}`
      );
      const bookingData = response.data || [];
      // const DataDetails = bookingData.map((gfd: any) => gfd.booking);

      // getinvoiceData(usersData);
      // setUsers(usersData);
      // console.log(DataDetails, "sjgfksdfguysldgfusdgfuy");
      bookingIdSet(bookingData);
    } catch (error) {
      console.error("Error fetching user booking data:", error);
    }
  };
  const [bookingDetails, setBookingDetails] = useState();
  const getBookingDetails = async (event: any) => {
    const BookingId = event.value.id;
    setSelectBookingIds(event.value);
    const responceInvoiceData = await axios.get(
      `${baseUrl}odata/GetAllInvoiceByBookingId?bookingId=${BookingId}`
    );
    const invoiceId =
      responceInvoiceData.data.length !== 0
        ? responceInvoiceData.data[0].invoiceCode
        : 0;
    setInvoiceNumber(invoiceId);

    console.log(invoiceId, "wsdfghjkjhgfdsdfghjk");
    setInvoiceEnabler(true);
    setSelectBookingId(event.value);
    console.log(event.value, "wertyuidfghj");
    setdeposit(event.value.deposit);

    try {
      const response = await axios.get(
        `${baseUrl}odata/GetAllTaxType?$filter=IsActive%20eq%20true`
      );

      const selectTaxs = response.data.find(
        (taxData: any) => taxData.id === event.value.taxId
      );
      setSelectedTax(selectTaxs);
      const responsecgstigst = await axios.get(
        `${baseUrl}odata/GetCGSTSGSTDetails?taxId=${event.value.taxId}&bookingId=${BookingId}`
      );

      const taxcget = responsecgstigst.data.cgstDetail;
      const taxsget = responsecgstigst.data.cgstDetail;
      const DataAdd = (taxcget.percentage + taxsget.percentage) / 100;
      console.log(selectTaxs, "1234rfvgbhjytrfdcv");
      setTaxRate(DataAdd);
      setRentAmount(parseInt(event.value.spaceRent));
      const rowDetails = [
        {
          type: "Space Rent",
          description: "",
          rent: event.value.spaceRent,
          discount: 0,
          // taxRate: selectTaxs,
          subTotal: event.value.spaceRent,
        },
      ];

      setRows(rowDetails);
    } catch (e) {}
    getSpaceId(event.value.spaceId);

    try {
      const responseSpace = await axios.get(
        `${baseUrl}odata/SpaceHeaders(${event.value.spaceId})`
      );

      const responseDuration = await axios.get(
        `${baseUrl}odata/Durations/${event.value.durationId}`
      );
      console.log(responseSpace.data, "responseSpace");
      setSpaceIdValue(responseSpace.data.SpaceTypeId);
      if (responseDuration.data.value.length === 0) {
        // Alert(responseDuration.data.value);
      }
      setDurationId(responseDuration.data.value[0]);

      console.log(
        "setBookingCustomerDetails",
        new Date(BookingDetails?.BookingFrom!)
      );
      console.log(event.value, "qwertyuioijuhgfdsxcvbhnjm");
      setBookingDetails(event.value);
      setBookingCustomerDetails({
        SpaceBooked: responseSpace.data.SpaceTypeName,
        BookingDate: event.value.bookingDatetime,
        BookingFrom: new Date(event.value.bookingFrom),
        BookingTo: new Date(event.value.bookingTo),
        Duration: responseDuration.data.value[0].DurationType,
        Deposit: event.value.deposit,
        TotalCost: event.value.totalAmount,
      });
      setDurationType(responseDuration.data.value[0].DurationType);
      setDetailsEnabler(true);
    } catch (error) {
      console.error("Error fetching user booking data:", error);
    }
  };

  const [durationId, setDurationId] = useState();

  const addDetailInvoice = async () => {
    // setLoader(true);
    const bookingId = bookingDetails !== undefined ? bookingDetails["id"] : 0;
    const selectedDurationId = durationId !== undefined ? durationId["Id"] : 0;
    const DetailsSet = {
      statusId: 3,
      bookingId: bookingId,
      spaceBookedId: spaceIdValue,

      periodStart: BookingDetails?.BookingFrom,
      periodEnd: BookingDetails?.BookingTo,
      bookingDate: BookingDetails?.BookingDate + ".000Z",

      durationId: selectedDurationId,
      totalCost: BookingDetails?.TotalCost,

      name: customerDetails?.Name,
      mobile: customerDetails?.Mobile,
      email: customerDetails?.Email,
      address: customerDetails?.Address,

      termsConditionsId: 0,
      addendum: "",

      invoiceNumber: invoiceNumber,
      staffName: staffName,
      staffDesignation: staffDes,
      staffDesignationId: staffNameId,
    };
    console.log(DetailsSet);
    // statusId: 3,
    // bookingId: bookingId,
    // spaceBookedId: spaceIdValue,
    // periodStart: BookingDetails?.BookingFrom,
    // periodEnd: BookingDetails?.BookingTo,
    // bookingDate: BookingDetails?.BookingDate,
    // durationId: selectedDurationId,
    // totalCost: BookingDetails?.TotalCost,
    // name: customerDetails?.Name,
    // mobile: customerDetails?.Mobile,
    // email: customerDetails?.Email,
    // address: customerDetails?.Address,
    // termsConditionsId: 0,
    // addendum: "",
    // invoiceNumber: invoiceNumber,
    // staffName: staffName,
    // staffDesignation: staffDes,

    try {
      const response = await axios.post(
        `${baseUrl}odata/Contracts`,
        DetailsSet
      );
      console.log(response.data.Id, "<-responceData");
      // uploadDocumentFiles(response.data.Id); - Sign flow
      createContractAndDownload(response.data.file.fileContents);
      statusDialogSet(true);
      setLoader(false);
      alertSet("Contract created successfully");
    } catch (err) {
      console.log(err, "save");
      setLoader(false);
    }
  };

  //upload Image
  const uploadDocumentFiles = async (contractId: String) => {
    let header = {
      "Content-Type":
        "application/json;odata.metadata=minimal;odata.streaming=true",
      accept: "*/*",
    };
    let uploadData = [
      {
        docUploadGuid: currentFilestaff?.uid,
        docUploadRefType: "Sign",
        docUploadRefNo: contractId,
        docUploadRefSubType: "staff",
        image: [
          {
            value: imageDatastaff,
            fileName: currentFilestaff?.name,
            type: currentFilestaff?.extension?.split(".").pop(),
          },
        ],
      },
      {
        docUploadGuid: currentFilestaff?.uid,
        docUploadRefType: "Sign",
        docUploadRefNo: contractId,
        docUploadRefSubType: "customer",
        image: [
          {
            value: imageDatacustomer,
            fileName: currentFilecustomer?.name,
            type: currentFilecustomer?.extension?.split(".").pop(),
          },
        ],
      },
      {
        docUploadGuid: currentFilestaff?.uid,
        docUploadRefType: "Sign",
        docUploadRefNo: contractId,
        docUploadRefSubType: "witness1",
        image: [
          {
            value: imageDatav1,
            fileName: currentFilev1?.name,
            type: currentFilev1?.extension?.split(".").pop(),
          },
        ],
      },
      {
        docUploadGuid: currentFilestaff?.uid,
        docUploadRefType: "Sign",
        docUploadRefNo: contractId,
        docUploadRefSubType: "witness2",
        image: [
          {
            value: imageDatav2,
            fileName: currentFilev2?.name,
            type: currentFilev2?.extension?.split(".").pop(),
          },
        ],
      },
    ];

    console.log(uploadData, "sdfghjkjwyofgwau");
    try {
      const response = await axios.post(
        `${baseUrl}odata/JsonUpload`,
        uploadData,
        {
          headers: header,
        }
      );
      if (response.status === 200) {
        statusDialogSet(true);
        setLoader(false);
        alertSet("Contract created successfully");
      } else {
        console.log("else upload");
        setLoader(false);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const createContractAndDownload = async (contractData: any) => {
    const blob = base64ToBlob(contractData);
    const url = window.URL.createObjectURL(blob);
    // Create a link element and trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = "Contract.pdf"; // Default name for the downloaded file
    document.body.appendChild(link);
    link.click();
    // Clean up the URL object
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const navigateBack = () => {
    if (alertState === false) {
      navigate("/masters/contractmaster");
      window.scrollTo(0, 0);
    }
    statusDialogSet(false);
  };

  const onChangeValue = (e: any) => {
    console.log("onChangeValue", e.value);
    setStaffName(e.value.name);
    setStaffNameId(e.value.id);
    setSelectStaffName(e.value);
    MemberListAPI(e.value.roleId);
  };

  const MemberListAPI = async (roleId: any) => {
    try {
      const response = await axios.get(`${baseUrl}odata/UserRoles`);
      const memberRole = response.data.value;
      const roleName = memberRole.find((item: any) => item.Id === roleId);
      setStaffDes(roleName.Name);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div className="dashboard-bg" style={{ padding: "10px" }}>
      {loader === true ? (
        <div className="loader">
          <Loader size="large" type={"converging-spinner"} />
        </div>
      ) : (
        <div>
          <div className="overall-view">
            <div>
              <div className="dashboard-button">
                <Breadcrumbs breadCrumbData={breadCrumbsData} />
              </div>
              <hr className="hr-border" />
            </div>
          </div>
          <div className="overall-view">
            {/* Detail Screen*/}
            <div className="form-row-create">
              <div className="form-group">
                <Label>User Name</Label>
                <DropDownList
                  className="book-dropdown-new"
                  data={users}
                  disabled={view}
                  textField="Name"
                  value={selectUser}
                  onChange={(event) => {
                    bookingIdSet(undefined);
                    setInvoiceEnabler(false);
                    setSelectBookingId({
                      Id: 0,
                      bookingId: "Select Booking Id",
                    });
                    getinvoiceData(event.value);
                    setSelectUser(event.value);
                    console.log(event.value, "ertyukittyguuyutygigwetrb0q3t5");

                    fetchUserBooking(event.value.Id);
                    setBookingIdEnabler(true);
                    setDetailsEnabler(false);
                  }}
                  name="Name"
                />
              </div>

              {bookingIdEnabler === true ? (
                <div
                  className="form-group"
                  style={{ padding: "0px 10px 0px 0px" }}
                >
                  <Label>Booking ID</Label>
                  {selectBookingId.bookingId !== undefined ? (
                    <div>
                      <DropDownList
                        className="book-dropdown-new"
                        data={bookingId}
                        disabled={view}
                        textField="bookingId"
                        value={selectBookingIds}
                        onChange={(event) => getBookingDetails(event)}
                        name="bookingId"
                      />
                    </div>
                  ) : (
                    <DropDownList
                      className="book-dropdown-new"
                      data={bookingId}
                      disabled={view}
                      textField="BookingId"
                      value={selectBookingId}
                      onChange={(event) => getBookingDetails(event)}
                      name="bookingID"
                    />
                  )}
                </div>
              ) : (
                <div></div>
              )}

              <div className="form-group">
                {invoiceidEnabler === true ? (
                  <div>
                    <Label>Invoice ID</Label>
                    <Input
                      type="text"
                      disabled={true}
                      name="percentageBooking"
                      className="book-dropdown-new"
                      value={invoiceNumber}
                      onChange={(e) => {
                        setInvoiceNumber(e.value);
                      }}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              <div className="form-group"></div>
            </div>
            <div>
              {detailsEnabler === true ? (
                <div>
                  <div className="form-row-create">
                    <div className="form-group" style={{}}>
                      <Label>Staff Name</Label>
                      {locations.state !== null ? (
                        <Input
                          type="text"
                          name="percentageBooking"
                          className="book-dropdown-new"
                          placeholder="Enter Staff Name"
                          value={staffName}
                          disabled={view}
                          maxLength={25}
                          onChange={(e) => {
                            if (/^[a-zA-Z\s]*$/.test(e.value)) {
                              setStaffName(e.value);
                            }
                          }}
                        ></Input>
                      ) : (
                        <DropDownList
                          className="book-dropdown-new"
                          data={staffData}
                          disabled={view}
                          textField="name"
                          dataItemKey="id"
                          value={selectStaffName}
                          onChange={onChangeValue}
                          name="name"
                        />
                      )}
                      {staffNameError && (
                        <span style={{ color: "red" }} className="error">
                          {staffNameError}
                        </span>
                      )}
                    </div>
                    <div className="form-group" style={{}}>
                      <Label>Staff Designation</Label>
                      {/* <DropDownList
                        className="book-dropdown-new"
                        data={staffData}
                        disabled={view}
                        textField="name"
                        dataItemKey="id"
                        value={selectDesignation}
                        onChange={onChangeValue}
                        name="name"
                      /> */}
                      <Input
                        type="text"
                        name="percentageBooking"
                        className="book-dropdown-new"
                        placeholder="Enter Staff Designation"
                        value={staffDes}
                        disabled
                        maxLength={40}
                        onChange={(e) => {
                          if (/^[a-zA-Z\s]*$/.test(e.value)) {
                            setStaffDes(e.value);
                          }
                        }}
                      ></Input>
                      {staffDesError && (
                        <span style={{ color: "red" }} className="error">
                          {staffDesError}
                        </span>
                      )}
                    </div>
                    <div className="form-group" style={{}}></div>
                  </div>
                  <hr className="hr-border" />
                  {/* <div style={{ backgroundColor: "#eef3f2" }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div
                        className="booking-details"
                        style={{ padding: "10px", width: "50%" }}
                      >
                        <h4>Space Booked</h4>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",

                            width: "100%",
                            padding: "20px",
                          }}
                        >
                          <div className="form-row-create">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Space Booked</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {BookingDetails?.SpaceBooked}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Booking Date</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {BookingDetails?.BookingDate !== null
                                    ? `${formatDateDMY(
                                        `${BookingDetails?.BookingDate}`
                                      )}`
                                    : ""}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Duration</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {BookingDetails?.Duration}
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Deposit</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {BookingDetails?.Deposit}
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Total Cost</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {BookingDetails?.TotalCost}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          width: "1px",
                          backgroundColor: "grey",
                          color: "black",
                        }}
                      >
                        {"."}
                      </div>

                      <div
                        className="booking-details"
                        style={{ padding: "10px", width: "50%" }}
                      >
                        <h4>Customer Details</h4>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",

                            width: "100%",
                            padding: "20px",
                          }}
                        >
                          <div className="form-row-create">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Name</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {" "}
                                  {customerDetails?.Name}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Mobile</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {customerDetails?.Mobile}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Email</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {customerDetails?.Email === null
                                    ? ""
                                    : customerDetails?.Email}
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div className="form-group">
                                <div>Address</div>

                                <div style={{ fontWeight: "bold" }}>
                                  {customerDetails?.Address}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div style={{ backgroundColor: "#eef3f2", padding: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Space Booked Section */}
                      <div
                        className="booking-details"
                        style={{
                          width: "48%",
                          backgroundColor: "#ffffff",
                          padding: "20px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <h4 style={{ textAlign: "left", marginBottom: "20px" }}>
                          Space Booked
                        </h4>
                        <div className="form-row-create">
                          <div className="form-group">
                            <div>Space Booked</div>
                            <div style={{ fontWeight: "bold" }}>
                              {BookingDetails?.SpaceBooked}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Booking Date</div>
                            <div style={{ fontWeight: "bold" }}>
                              {BookingDetails?.BookingDate
                                ? formatDateDMY(
                                    `${BookingDetails?.BookingDate}`
                                  )
                                : ""}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Duration</div>
                            <div style={{ fontWeight: "bold" }}>
                              {BookingDetails?.Duration}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Deposit</div>
                            <div style={{ fontWeight: "bold" }}>
                              {BookingDetails?.Deposit}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Total Cost</div>
                            <div style={{ fontWeight: "bold" }}>
                              {BookingDetails?.TotalCost}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Divider */}
                      <div
                        style={{
                          width: "2px",
                          backgroundColor: "grey",
                          margin: "0 10px",
                          height: "auto",
                        }}
                      />

                      {/* Customer Details Section */}
                      <div
                        className="booking-details"
                        style={{
                          width: "48%",
                          backgroundColor: "#ffffff",
                          padding: "20px",
                          borderRadius: "8px",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <h4 style={{ textAlign: "left", marginBottom: "20px" }}>
                          Customer Details
                        </h4>
                        <div className="form-row-create">
                          <div className="form-group">
                            <div>Name</div>
                            <div
                              style={{
                                fontWeight: "bold",
                                wordBreak: "break-word",
                              }}
                            >
                              {customerDetails?.Name}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Mobile</div>
                            <div style={{ fontWeight: "bold" }}>
                              {customerDetails?.Mobile}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Email</div>
                            <div
                              style={{
                                fontWeight: "bold",
                                wordBreak: "break-word",
                              }}
                            >
                              {customerDetails?.Email || ""}
                            </div>
                          </div>
                          <div className="form-group">
                            <div>Address</div>
                            <div
                              style={{
                                fontWeight: "bold",
                                wordBreak: "break-word",
                              }}
                            >
                              {customerDetails?.Address}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-row-create">
                    <div className="form-group" style={{}}>
                      <Label>
                        Booking Start Date{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <style>{customStyles}</style>
                      <div className="no-wheel" style={{ width: "100%" }}>
                        <MyDatePicker
                          minDate={new Date()} // Start date can't be in the past
                          checkInDate={new Date(BookingDetails?.BookingFrom!)}
                          isDisableCheck={true}
                          customFormatter={false}
                          setCheckInDate={(e: any) => {
                            handleStartDateChange(e);
                          }}
                        />
                      </div>

                      {errorstartDate && (
                        <p style={{ color: "red" }}>{errorstartDate}</p>
                      )}
                    </div>
                    <div className="form-group" style={{}}>
                      <Label>
                        Booking End Date <span style={{ color: "red" }}>*</span>
                      </Label>
                      <style>{customStyles}</style>
                      <div className="no-wheel" style={{ width: "100%" }}>
                        <MyDatePicker
                          minDate={startDate || new Date()} // End date must be >= start date
                          checkInDate={new Date(BookingDetails?.BookingTo!)}
                          isDisableCheck={true}
                          customFormatter={false}
                          setCheckInDate={(e: any) => {
                            handleEndDateChange(e);
                          }}
                        />
                      </div>

                      {errorDate && <p style={{ color: "red" }}>{errorDate}</p>}
                    </div>
                    <div className="form-group" style={{}}></div>
                  </div>

                  <div className="form-row-create">
                    <div className="form-group" style={{}}></div>
                  </div>

                  {/* <div className="form-row-create">
                      <div className="form-group" style={{}}>
                        <Label>Terms and Conditions</Label>
                        <DropDownList
                          className="book-dropdown-new"
                          data={termsOptions}
                          value={selectedOption}
                          onChange={(e) => setSelectedOption(e.value)}
                          style={{ width: "300px", marginBottom: "20px" }}
                        />
                      </div>
                    </div> */}

                  <div style={{ padding: "20px" }}>
                    {/* <Label>Addendum</Label>
                      <Editor
                        tools={[
                          [Bold, Italic, Underline, Strikethrough],
                          [OrderedList, UnorderedList, Indent, Outdent],
                          [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                        ]}
                        contentStyle={{ height: 200 }}
                        onChange={handleEditorChange}
                      /> */}

                    {/* Sign flow  */}
                    {/* <div className="form-row-create">
                      <div className="form-group" style={{}}>
                        <h3 style={{ marginTop: "20px" }}>Staff Signature</h3>

                        <div>
                          {locations.state !== null ? (
                            img4 !== undefined ? (
                              <img
                                src={`${imageBaseUrl}${img1}`}
                                height={"120px"}
                              ></img>
                            ) : (
                              <div></div>
                            )
                          ) : (
                            <div>
                              {staffImageError && (
                                <span
                                  style={{ color: "red" }}
                                  className="error"
                                >
                                  {staffImageError}
                                </span>
                              )}

                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <h6>e-Sign by : </h6>
                                  <div style={{ width: "50px" }}></div>
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group2"
                                    value={2}
                                    checked={selectedValuestaff === "2"}
                                    label="Upload Files"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuestaffSet(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                      console.log(
                                        "Value changed from first to second"
                                      );
                                    }}
                                  />
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group3"
                                    value={3}
                                    checked={selectedValuestaff === "3"}
                                    label="Draw Signature"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuestaffSet(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                {selectedValuestaff === "2" ? (
                                  <div>
                                    <Label>
                                      Upload File{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <ExternalDropZone
                                      className="field-space border-file-upload"
                                      uploadRef={uploadRefs}
                                      customHint={hint}
                                      customNote={note}
                                    />
                                    <div
                                      className="center-view"
                                      style={{ paddingTop: "10px" }}
                                    >
                                      <Upload
                                        ref={uploadRefs}
                                        restrictions={{
                                          maxFileSize: 2000000,
                                          allowedExtensions: [
                                            " .jpeg",
                                            ".png",
                                            ".jpg",
                                            ".pdf",
                                          ],
                                        }}
                                        batch={false}
                                        multiple={false}
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        saveUrl={onSaveRequeststaff}
                                        removeUrl={onRemoveRequeststaff}
                                      />
                                      {errorimageMessage && (
                                        <div style={{ color: "red" }}>
                                          {errorimageMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : selectedValuestaff === "3" ? (
                                  <div>
                                    <div className="example">
                                      <div className="content-wrapper">
                                        <ToolbarItem className="toolbar-tool">
                                          Upload your signature:
                                        </ToolbarItem>

                                        <div className="signature-wrapper">
                                          <Signature
                                            value={value}
                                            onChange={handleChangestaff}
                                            color={""}
                                            backgroundColor={""}
                                            strokeWidth={2}
                                            smooth={true}
                                            maximizable={true}
                                            hideLine={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="form-group" style={{}}>
                        <h3 style={{ marginTop: "20px" }}>
                          Customer Signature
                        </h3>
                        <div>
                          {locations.state !== null ? (
                            img2 !== undefined ? (
                              <img
                                src={`${imageBaseUrl}${img2}`}
                                height={"120px"}
                              ></img>
                            ) : (
                              <div></div>
                            )
                          ) : (
                            <div>
                              {customerImageError && (
                                <span
                                  style={{ color: "red" }}
                                  className="error"
                                >
                                  {customerImageError}
                                </span>
                              )}
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <h6>e-Sign by : </h6>
                                  <div style={{ width: "50px" }}></div>
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group2"
                                    value={2}
                                    checked={selectedValuecustomer === "2"}
                                    label="Upload Files"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuecustomerSet(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                      console.log(
                                        "Value changed from first to second"
                                      );
                                    }}
                                  />
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group3"
                                    value={3}
                                    checked={selectedValuecustomer === "3"}
                                    label="Draw Signature"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuecustomerSet(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                {selectedValuecustomer === "2" ? (
                                  <div>
                                    <Label>
                                      Upload File{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <ExternalDropZone
                                      className="field-space border-file-upload"
                                      uploadRef={uploadRefs}
                                      customHint={hint}
                                      customNote={note}
                                    />
                                    <div
                                      className="center-view"
                                      style={{ paddingTop: "10px" }}
                                    >
                                      <Upload
                                        ref={uploadRefs}
                                        restrictions={{
                                          maxFileSize: 2000000,
                                          allowedExtensions: [
                                            " .jpeg",
                                            ".png",
                                            ".jpg",
                                            ".pdf",
                                          ],
                                        }}
                                        batch={false}
                                        multiple={false}
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        saveUrl={onSaveRequestCustomer}
                                        removeUrl={onRemoveRequestcustomer}
                                      />
                                      {errorimageMessage && (
                                        <div style={{ color: "red" }}>
                                          {errorimageMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : selectedValuecustomer === "3" ? (
                                  <div>
                                    <div className="example">
                                      <div className="content-wrapper">
                                        <ToolbarItem className="toolbar-tool">
                                          Upload your signature:
                                        </ToolbarItem>

                                        <div className="signature-wrapper">
                                          <Signature
                                            value={value}
                                            onChange={handleChangecustomer}
                                            color={""}
                                            backgroundColor={""}
                                            strokeWidth={2}
                                            smooth={true}
                                            maximizable={true}
                                            hideLine={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="form-row-create">
                      <div className="form-group" style={{}}>
                        <h3 style={{ marginTop: "20px" }}>
                          Witness Signature 1
                        </h3>

                        <div>
                          {locations.state !== null ? (
                            img3 !== undefined ? (
                              <img
                                src={`${imageBaseUrl}${img3}`}
                                height={"120px"}
                              ></img>
                            ) : (
                              <div></div>
                            )
                          ) : (
                            <div>
                              {witness1Error && (
                                <span
                                  style={{ color: "red" }}
                                  className="error"
                                >
                                  {witness1Error}
                                </span>
                              )}

                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <h6>e-Sign by : </h6>
                                  <div style={{ width: "50px" }}></div>
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group2"
                                    value={2}
                                    checked={selectedValuev1 === "2"}
                                    label="Upload Files"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      setSelectedValuev1(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                      console.log(
                                        "Value changed from first to second"
                                      );
                                    }}
                                  />
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group3"
                                    value={3}
                                    checked={selectedValuev1 === "3"}
                                    label="Draw Signature"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      setSelectedValuev1(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                {selectedValuev1 === "2" ? (
                                  <div>
                                    <Label>
                                      Upload File{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <ExternalDropZone
                                      className="field-space border-file-upload"
                                      uploadRef={uploadRefs}
                                      customHint={hint}
                                      customNote={note}
                                    />
                                    <div
                                      className="center-view"
                                      style={{ paddingTop: "10px" }}
                                    >
                                      <Upload
                                        ref={uploadRefs}
                                        restrictions={{
                                          maxFileSize: 2000000,
                                          allowedExtensions: [
                                            " .jpeg",
                                            ".png",
                                            ".jpg",
                                            ".pdf",
                                          ],
                                        }}
                                        batch={false}
                                        multiple={false}
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        saveUrl={onSaveRequestv1}
                                        removeUrl={onRemoveRequestv1}
                                      />
                                      {errorimageMessage && (
                                        <div style={{ color: "red" }}>
                                          {errorimageMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : selectedValuev1 === "3" ? (
                                  <div>
                                    <div className="example">
                                      <div className="content-wrapper">
                                        <ToolbarItem className="toolbar-tool">
                                          Upload your signature:
                                        </ToolbarItem>

                                        <div className="signature-wrapper">
                                          <Signature
                                            value={value}
                                            onChange={handleChangev1}
                                            color={""}
                                            backgroundColor={""}
                                            strokeWidth={2}
                                            smooth={true}
                                            maximizable={true}
                                            hideLine={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="form-group" style={{}}>
                        <h3 style={{ marginTop: "20px" }}>
                          Witness Signature 2
                        </h3>

                        <div>
                          {locations.state !== null ? (
                            img1 !== undefined ? (
                              <img
                                src={`${imageBaseUrl}${img4}`}
                                height={"120px"}
                              ></img>
                            ) : (
                              <div></div>
                            )
                          ) : (
                            <div>
                              {witness2Error && (
                                <span
                                  style={{ color: "red" }}
                                  className="error"
                                >
                                  {witness2Error}
                                </span>
                              )}

                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <h6>e-Sign by : </h6>
                                  <div style={{ width: "50px" }}></div>
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group2"
                                    value={2}
                                    checked={selectedValuev2 === "2"}
                                    label="Upload Files"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuev2Set(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                      console.log(
                                        "Value changed from first to second"
                                      );
                                    }}
                                  />
                                  <div style={{ width: "30px" }}></div>
                                  <RadioButton
                                    name="group3"
                                    value={3}
                                    checked={selectedValuev2 === "3"}
                                    label="Draw Signature"
                                    onChange={(e) => {
                                      console.log("Value changed -->", e.value);
                                      selectedValuev2Set(`${e.value}`);
                                      if (e.value === "") {
                                        newVarientErrorSet("select feild");
                                      } else {
                                        newVarientErrorSet("");
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div>
                                {selectedValuev2 === "2" ? (
                                  <div>
                                    <Label>
                                      Upload File{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </Label>
                                    <ExternalDropZone
                                      className="field-space border-file-upload"
                                      uploadRef={uploadRefs}
                                      customHint={hint}
                                      customNote={note}
                                    />
                                    <div
                                      className="center-view"
                                      style={{ paddingTop: "10px" }}
                                    >
                                      <Upload
                                        ref={uploadRefs}
                                        restrictions={{
                                          maxFileSize: 2000000,
                                          allowedExtensions: [
                                            " .jpeg",
                                            ".png",
                                            ".jpg",
                                            ".pdf",
                                          ],
                                        }}
                                        batch={false}
                                        multiple={false}
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        saveUrl={onSaveRequestv2}
                                        removeUrl={onRemoveRequestv2}
                                      />
                                      {errorimageMessage && (
                                        <div style={{ color: "red" }}>
                                          {errorimageMessage}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : selectedValuev2 === "3" ? (
                                  <div>
                                    <div className="example">
                                      <div className="content-wrapper">
                                        <ToolbarItem className="toolbar-tool">
                                          Upload your signature:
                                        </ToolbarItem>

                                        <div className="signature-wrapper">
                                          <Signature
                                            value={value}
                                            onChange={handleChangev2}
                                            color={""}
                                            backgroundColor={""}
                                            strokeWidth={2}
                                            smooth={true}
                                            maximizable={true}
                                            hideLine={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div> */}

                    <div
                      className="center-view"
                      style={{
                        paddingBottom: "50px",
                      }}
                    >
                      <div className="form-row-area">
                        <div className="form-group-area"></div>
                      </div>
                      <div className="button-group">
                        {view === true ? (
                          <div></div>
                        ) : (
                          // <Button className="button-view" onClick={() => {}}>
                          //   {loader === false ? "UPDATE" : "Loading..."}
                          // </Button>
                          <Button
                            className="button-view"
                            onClick={() => {
                              handleSubmit();
                            }}
                          >
                            {loader === false ? "CREATE" : "Loading..."}
                          </Button>
                        )}
                        <Button
                          // type="submit"
                          className="common-button-view"
                          onClick={() => {
                            navigate("/masters/contractmaster");
                          }}
                        >
                          CANCEL
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </div>
            {statusDialog && (
              <Dialog>
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <h3>{alert}</h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: "30px",
                    }}
                  >
                    <Button
                      className="button-view"
                      onClick={() => navigateBack()}
                    >
                      Ok
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const dataURLtoBlob = (dataurl: string): Blob => {
  if (!dataurl) {
    throw new Error("Invalid data URL");
  }

  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1]; // Safely match MIME type
  if (!mime) {
    throw new Error("Invalid MIME type");
  }

  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};
